import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import HomePage from "../Pages/HomePage/HomePage";
import LoginPage from "../Pages/LoginPage/LoginPage";
import RegisterPage from "../Pages/RegisterPage/RegisterPage";
import ProtectedRoute from "./ProtectedRoute";
import { useAuth } from "../Context/useAuth";
import AddRevision from "../Components/AddRevision/AddRevision";
import AddRule from "../Components/AddRule/AddRule";
import CheckRevision from "../Components/CheckRevision/CheckRevision";
import MyRevisions from "../Components/MyRevisions/MyRevisions";
import HistoricalRevisions from "../Components/HistoricalRevisions/HistoricalRevisions";
import AllRules from "../Components/AllRules/AllRules";

const DefaultPage = () => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn() ? <Navigate to="/home" /> : <LoginPage />;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <DefaultPage /> },
      { path: "login", element: <LoginPage /> },
      { path: "register", element: <RegisterPage /> },
      {
        path: "home",
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="check-revision" replace /> },
          { path: "add-revision", element: <AddRevision /> },
          { path: "add-rule", element: <AddRule /> },
          { path: "check-revision", element: <CheckRevision /> },
          { path: "my-revisions", element: <MyRevisions /> },
          { path: "historical-revisions", element: <HistoricalRevisions /> },
          { path: "all-rules", element: <AllRules /> },
        ],
      },
    ],
  },
]);
